import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getRespondidoMultiplosPerfis } from "services/pesquisa";
import { RootState } from "store";
import ModalExperienciaObrigado from "./agradecimento";
import ModalExperienciaConvite from "./convite";
import ModalExperienciaFormulario from "./formulario";

const ModalExperiencia = () => {
  const auth = useSelector((state: RootState) => state.auth);
  const languageValues = useSelector((state: RootState) => state.languages.languageValues);
  const perfilPermitido = [
    "pufv_professor",
    "pufv_professor_gestor",
    "pufv_assessor_pedagogico",
    "pufv_assessor_pedagogico_gestor",
    "pufv_coordenador_local",
  ];
  const perfilUsuario = auth?.userData?.profile?.perfil;
  const perfilCarregado = !!perfilUsuario;
  const modalShown = sessionStorage.getItem("modalAvisoShown");
  const pesquisaFetch = sessionStorage.getItem("pesquisaFetch");
  const [etapa, setEtapa] = useState<"convite" | "formulario" | "agradecimento" | "fechado" | null>(null);

  useEffect(() => {
    if (etapa === null) {
      const fetchData = async () => {
        const { data } = await getRespondidoMultiplosPerfis();
        const isRespondido = data.respondido;
        const podeAbrir =
          perfilCarregado &&
          perfilPermitido.includes(perfilUsuario) &&
          modalShown !== 'true' &&
          isRespondido === false;

        sessionStorage.setItem('pesquisaFetch', 'true');
        setEtapa(podeAbrir ? "convite" : "fechado");
      };
      if ((pesquisaFetch !== 'true' || modalShown !== 'true') && perfilPermitido.includes(perfilUsuario)) fetchData();
    }
    // eslint-disable-next-line
  }, [etapa, perfilCarregado, perfilUsuario, modalShown, pesquisaFetch]);

  if (!perfilCarregado || !perfilPermitido.includes(perfilUsuario) || etapa === "fechado") {
    return null;
  }

  return (
    <>
      {etapa === "convite" && (
        <ModalExperienciaConvite
          open
          languageValues={languageValues}
          onNext={() => setEtapa("formulario")}
          onClose={(mostrarNovamente: boolean) => {
            if (mostrarNovamente)
              sessionStorage.setItem('modalAvisoShown', 'true');
            setEtapa("fechado");
          }}
        />
      )}
      {etapa === "formulario" && (
        <ModalExperienciaFormulario
          open
          languageValues={languageValues}
          onSuccess={() => setEtapa("agradecimento")}
          onClose={() => setEtapa("fechado")}
        />
      )}
      {etapa === "agradecimento" && (
        <ModalExperienciaObrigado
          open
          languageValues={languageValues}
          onClose={() => setEtapa("fechado")}
        />
      )}
    </>
  );
};

export default ModalExperiencia;
